import { createContext, useContext, useId, type FC, type ReactNode } from "react";

interface CampaignStepCardChrome {
  stepLabel?: ReactNode;
  footer?: ReactNode;
}

export const CampaignStepCardChromeContext = createContext<CampaignStepCardChrome>({});

interface CampaignStepCardProps {
  title: string;
  children: ReactNode;
  subtitle?: string;
  headerAction?: ReactNode;
  footer?: ReactNode;
  wide?: boolean;
  className?: string;
  titleSuffix?: ReactNode;
}

const CampaignStepCard: FC<CampaignStepCardProps> = ({
  title,
  children,
  subtitle,
  headerAction,
  footer,
  wide = false,
  className = "",
  titleSuffix,
}) => {
  const titleId = useId();
  const chrome = useContext(CampaignStepCardChromeContext);

  return (
    <section
      className={`campaign-flow__card ${wide ? "campaign-flow__card--wide" : ""} ${className}`}
      aria-labelledby={titleId}
    >
      <div className="campaign-flow__card-content">
        {chrome.stepLabel && <div className="campaign-flow__step-label">{chrome.stepLabel}</div>}
        <header className="campaign-flow__card-header">
          <div className="campaign-flow__card-heading">
            <h2 id={titleId} className="campaign-flow__card-title">
              {title}
              {titleSuffix}
            </h2>
            {subtitle && <p className="campaign-flow__card-subtitle">{subtitle}</p>}
          </div>
          {headerAction}
        </header>
        {children}
      </div>
      {footer && <div className="campaign-flow__card-footer">{footer}</div>}
      {chrome.footer && <div className="campaign-flow__card-footer">{chrome.footer}</div>}
    </section>
  );
};

export default CampaignStepCard;
